import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import * as customerActions from "../../actions/customerActions";
import * as codeActions from "../../actions/codeActions";
import * as supportTicketActions from "../../actions/supportTicketActions";
import * as modalActions from "../../actions/modalActions";
import * as projectActions from "../../actions/projectActions";
import * as contractActions from "../../actions/contractActions";
import * as userActions from "../../actions/userActions";

import CustomerService from "../../services/customerService";

import HeaderWrapper from "../common/HeaderWrapper";
import Alert from "../common/Alert";
import CustomerForm from "./CustomerForm";
import CustomerView from "./CustomerView";
import CustomerContractsPage from "./CustomerContractsPage";
import CustomerProjectsPage from "./CustomerProjectsPage";
import CustomerLocationsPage from "./locations/CustomerLocationsPage";
import CustomerContactsPage from "./contacts/CustomerContactsPage";
import CustomerNotesPage from "./notes/CustomerNotesPage";
import CustomerExpensePage from "./CustomerExpensePage";
import CollectionView from "./collections/CollectionView";
import CustomerTicketsPage from "./tickets";

class CustomerEditPage extends Component {
  constructor(props) {
    super(props);
    this.state = { customer: {}, editing: false };
  }

  componentDidMount = async () => {
    const customer = await CustomerService.getCustomer(
      this.props.match.params.id
    );
    this.props.actions.loadProjects();
    this.props.actions.loadCustomers();
    this.props.actions.loadContracts();
    this.props.actions.loadUsers();
    this.setState({ customer });
  };

  handleEdit = () => {
    this.setState({ editing: !this.state.editing });
  };

  handleCancel = () => {
    this.setState({ editing: false });
  };

  handleSave = (customer) => {
    this.props.actions.updateCustomer({
      ...customer,
      id: this.state.customer._id
    });
    this.setState({ editing: false });
  };

  render() {
    const { codes, saving, isMobile, auth, match, actions, supportTickets } =
      this.props;
    const { customer, editing } = this.state;

    return (
      <div id="info">
        <HeaderWrapper
          breadcrumbs={[{ label: customer.name }]}
          onClickEdit={auth.maxRole > 2000 && this.handleEdit}
          isMobile={isMobile}
        />
        <div style={{ margin: "15px 15px 0 15px" }}>
          <Alert show={customer?.bc_blocked === "All"}>
            <p>This customer’s account has been blocked in Business Central</p>
          </Alert>
        </div>
        {editing ? (
          <div className="content-wrapper">
            <CustomerForm
              customer={customer}
              codes={codes}
              saving={saving}
              editing={editing}
              onSave={this.handleSave}
              onCancel={this.handleCancel}
            />
          </div>
        ) : (
          <CustomerView customer={customer} />
        )}
        {auth.maxRole > 3000 && <CollectionView customer={customer} />}
        <CustomerContractsPage customer={customer} isMobile={isMobile} />
        <CustomerProjectsPage customer={customer} isMobile={isMobile} />
        <CustomerTicketsPage
          {...this.props}
          calls={
            Array.isArray(this.props.calls)
              ? this.props.calls
              : this.props.calls.calls || []
          }
          actions={actions}
          isMobile={isMobile}
          match={match}
          supportTickets={supportTickets}
        />
        <CustomerLocationsPage customer={customer} isMobile={isMobile} />
        <CustomerContactsPage customer={customer} isMobile={isMobile} />
        <CustomerExpensePage customer={customer} isMobile={isMobile} />
        <CustomerNotesPage
          customer={customer}
          isMobile={isMobile}
          auth={auth}
        />
      </div>
    );
  }
}

CustomerEditPage.propTypes = {
  actions: PropTypes.object.isRequired,
  saving: PropTypes.bool,
  codes: PropTypes.array,
  auth: PropTypes.object,
  isMobile: PropTypes.bool,
  match: PropTypes.object,
  supportTickets: PropTypes.array,
  users: PropTypes.array,
  calls: PropTypes.array,
  contracts: PropTypes.array,
  projects: PropTypes.array,
  customers: PropTypes.array,
  supportTicket: PropTypes.object
};

function mapStatesToProps(state) {
  return {
    state: state.reducers,
    customer: state.reducers.customer,
    saving: state.reducers.savingCustomer,
    codes: state.reducers.codes,
    auth: state.reducers.auth,
    supportTickets: state.reducers.supportTickets,
    users: state.reducers.users,
    calls: state.reducers.calls,
    contracts: state.reducers.contracts,
    projects: state.reducers.projects,
    customers: state.reducers.customers,
    supportTicket: state.reducers.supportTicket
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...customerActions,
        ...codeActions,
        ...supportTicketActions,
        ...modalActions,
        ...projectActions,
        ...contractActions,
        ...userActions
      },
      dispatch
    )
  };
}

export default connect(mapStatesToProps, mapDispatchToProps)(CustomerEditPage);
